import React from 'react';

export default function SourceInWidget(props) {
  const style = props.customStyle ? {textAlign: "left", paddingTop: "3px", fontSize: "14px", color: "#777", ...props.customStyle} : {textAlign: "left", paddingTop: "3px", fontSize: "10px", color: "#777"};
  return (
    <div style={style}>Source: dragonglass.me</div>
  );
}
